import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
	return (
		<nav aria-label="breadcrumb">
			<ol className="breadcrumb mt-2 mb-3">
				{items.map((item, i) =>
					<>
						{i === (items.length - 1) ?
							<li className="breadcrumb-item active" aria-current="page" key={item.title}>
								<small>{item.title}</small>
							</li>
						:
							<li className="breadcrumb-item" key={item.title}>
								<Link to={item.link}>
									<small>{item.title}</small>
								</Link>
							</li>
						}
					</>
				)}
			</ol>
		</nav>
	);
};

export default Breadcrumb;
